import { authenticatedAPI } from '../AuthenticatedAPI';
import {
  repeatedQuestionnaireFilloutStatusResDto,
  StoreRepeatedChecklistReqDto,
  storeRepeatedChecklistResDto,
} from '@web/common';
import { z } from 'zod';

export const getMyRepeatedQuestionnaireChecklist = async () => {
  return authenticatedAPI.get(`/api/repeated-questionnaires`, z.any());
};

export const storeMyRepeatedQuestionnaireChecklist = async (
  checklist: StoreRepeatedChecklistReqDto,
) => {
  return authenticatedAPI.put(
    `/api/repeated-questionnaires`,
    checklist,
    storeRepeatedChecklistResDto,
  );
};

export const getRepeatedQuestionnaireFilloutStatus = async () => {
  return authenticatedAPI.get(
    `/api/repeated-questionnaires/fillout-status`,
    repeatedQuestionnaireFilloutStatusResDto,
  );
};
